import type { SelectOption } from '@/components/ui/Select';

/**
 * Keep listbox rendering safe when an API returns partial, null, numeric, or
 * duplicate option fields. API data is untrusted at runtime even when callers
 * have a TypeScript SelectOption[] annotation.
 */
export function normalizeSelectOptions(
  options: readonly SelectOption[] | null | undefined,
): SelectOption[] {
  if (!Array.isArray(options)) return [];

  const seen = new Set<string>();
  const normalized: SelectOption[] = [];

  for (const rawOption of options as readonly unknown[]) {
    if (!rawOption || typeof rawOption !== 'object') continue;

    const option = rawOption as Record<string, unknown>;
    if (option.value == null) continue;

    const value = String(option.value);
    if (seen.has(value)) continue;
    seen.add(value);

    normalized.push({
      value,
      label: option.label == null || String(option.label).trim() === ''
        ? value
        : String(option.label),
      disabled: option.disabled === true,
    });
  }

  return normalized;
}
